import React from 'react'
import { Box } from '@mui/material'
import NextImage from 'next/image'
import { useIsResponsive } from '@/hooks'
import { EmtTypography } from 'emt-components-v2'
import AppRatingBox from './AppRatingBox'
import VeterinaryComponent from '@/components/pages/pet-sitter/reservations/NewRequest/VeterinaryComponent'
import VariantImages from '@/assets/VariantImages'
import AlreadyAccountBox from './AlreadyAccountBox'

const InitialLeftColumn: React.FC = () => {
  const [isMobile] = useIsResponsive()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        position: 'relative',
      }}
    >
      {!isMobile && (
        <Box>
          <EmtTypography variant={'h4'} fontWeight="800">
            Trouvez facilement un
          </EmtTypography>
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '0.3em' }}>
            <EmtTypography variant={'h4'} fontWeight="800" color="primary">
              Pet
            </EmtTypography>
            <NextImage className="inline" width={70} height={33} src={VariantImages.Sitter} alt="sitter" />
            <EmtTypography variant={'h4'} fontWeight="800">
              pour votre animal
            </EmtTypography>
          </Box>
        </Box>
      )}
      <VeterinaryComponent />
      {!isMobile && <AppRatingBox />}
      {!isMobile && <AlreadyAccountBox />}
    </Box>
  )
}

export default InitialLeftColumn
